var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { maybe } from "tsmonads";
import { isEmpty } from "ramda";
import { WebSocketMessage } from "../../serverConnection";
import OrderFormFirstStep from "./OrderFormFirstStep";
import OrderFormSecondStep from "./OrderFormSecondStep";
import OrderFormThirdStep from "./OrderFormThirdStep";
var OrderForm = /** @class */ (function (_super) {
    __extends(OrderForm, _super);
    function OrderForm(props) {
        var _this = _super.call(this, props) || this;
        _this.storeUser = function (user) {
            _this.setState({ user: user });
            _this.nextPage();
        };
        _this.storeOrder = function (order) {
            if (isEmpty(order.product)) {
                delete order.product;
            }
            _this.setState({ order: order });
            _this.nextPage();
        };
        _this.submitOrder = function (order) {
            _this.props.send(WebSocketMessage("users", "update", _this.state.user));
            _this.props.send(WebSocketMessage("orders", "update", order));
            _this.props.history.push("/orders");
        };
        _this.nextPage = function () {
            _this.setState({ page: _this.state.page + 1 });
        };
        _this.previousPage = function (order) {
            _this.setState({ page: _this.state.page - 1, order: order });
        };
        var orderId = _this.props.match.params.id;
        var order = orderId ? _this.props.orders.get(orderId) : undefined;
        var user = maybe(order)
            .map(function (o) { return _this.props.users.get(o.user); })
            .orUndefined();
        _this.state = {
            editingOrder: !!order,
            user: user,
            order: order,
            page: 1,
        };
        return _this;
    }
    OrderForm.prototype.render = function () {
        var _a = this.props, products = _a.products, currentUser = _a.currentUser;
        var page = this.state.page;
        return (React.createElement("div", { className: "container content" },
            React.createElement("h4", null, "Create Order"),
            React.createElement("br", null),
            React.createElement("div", { className: "card-panel" },
                React.createElement("h5", { className: "order__form_header" }, "Customer"),
                page === 1 && (React.createElement(OrderFormFirstStep, { enterprises: this.props.enterprises, currentUser: currentUser, oldCustomer: this.state.user, storeUser: this.storeUser, editMode: this.state.editingOrder }))),
            React.createElement("div", { className: "card-panel" },
                React.createElement("h5", { className: "order__form_header" }, "Product"),
                page === 2 && (React.createElement(OrderFormSecondStep, { enterprises: this.props.enterprises, currentUser: this.props.currentUser, products: products, previousPage: this.previousPage, storeOrder: this.storeOrder, oldOrder: this.state.order, customer: this.state.user, editMode: this.state.editingOrder }))),
            React.createElement("div", { className: "card-panel" },
                React.createElement("h5", { className: "order__form_header" }, "Specials"),
                page === 3 && (React.createElement(OrderFormThirdStep, { previousPage: this.previousPage, submit: this.submitOrder, order: this.state.order })))));
    };
    return OrderForm;
}(Component));
export default withRouter(OrderForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/orders/OrderForm.tsx
// module id = 1235
// module chunks = 0